import * as todos from '../../constants/todos'

export default (state = {}, action) => {
    switch (action.type) {
        case todos.TODOS_ADD_TODO_REQUEST:
            return { ...state, newTodoSave: false, newTodoError: false }
        case todos.TODOS_ADD_TODO_SUCCESS:
            return { ...state, modalShow: false, newTodoSave: true, newTodoError: false }
        case todos.TODOS_ADD_TODO_ERROR:
            return { ...state, newTodoSave: false, newTodoError: true }
        case todos.TODOS_FETCH_TODOS:
        case todos.TODOS_FETCH_TODO:
            return { ...state, ...action.payload }
        case todos.TODOS_ADD_TODO_MODAL_OPEN:
            return { ...state, modalShow: true, ...action.payload }
        case todos.TODOS_ADD_TODO_MODAL_CANCEL:
            return { ...state, modalShow: false }
        case todos.TODOS_TOGGLE_LIST:
            return { ...state, todoListOpen: !state.todoListOpen}
        case todos.TODOS_CLOSE_LIST:
            return { ...state, todoListOpen: false}
        default:
            return state;
    }
}